import localeFormatNumber, {
  localeConfig as importedLocaleConfig,
} from "/shared/helpers/number-formatter.helper";

export const localeConfig = importedLocaleConfig;

export default localeFormatNumber;
